import * as actions from './actions'
import * as getters from './getters'
import * as types from '../mutation-types'

const state = {
  news: {}
}

const mutations = {
  [types.FORGAMERS_NEWS] (state, data) {
    state.news = data
  }
}

export default {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
}



// WEBPACK FOOTER //
// ./src/vuex/forgamers/store.js